@if (diffField) {
  @for (line of diffField.lines; track $index) {
    <app-diff-line [line]="line"></app-diff-line>
  }
}
